// Package Imports
import { ScheduleOutlined } from '@ant-design/icons';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const TaskListResource: ResourceItem = {
  name: resourceName.myTask,
  identifier: ModuleIdentifierConst.TASKLIST_DASHBOARD,
  list: `${resourceName.myTask}`,
  show: `${resourceName.myTask}/show/:id`,
  options: { label: 'My tasks', icon: <ScheduleOutlined /> },
};

export default TaskListResource;
